/**
 * Typed errors of the AI agent API. Apart from `aiAgent.ts` so the chat helpers
 * (`@utils/aiChat`) can `instanceof` them while tests replace the API module
 * wholesale — a class read off a mocked module does not exist.
 */

/**
 * 409 `AI_TURN_IN_PROGRESS`: another answer is still being written in this
 * thread. Refused before the question was stored, so nothing the page appended
 * for this ask exists on the server.
 */
export class AiTurnInProgressError extends Error {
  readonly code = 'AI_TURN_IN_PROGRESS' as const;
  constructor() {
    super('another turn is in progress on this conversation');
    this.name = 'AiTurnInProgressError';
  }
}

/**
 * 429: the assistant's rate limit refused the request. Like the refusal above it
 * is decided before the route runs — nothing was stored — and it has a sentence
 * of its own: "something went wrong" sends the reader to try again at once,
 * which is the one thing that cannot work.
 */
export class AiRateLimitedError extends Error {
  readonly code = 'RATE_LIMITED' as const;
  constructor() {
    super('the assistant rate limit refused this request');
    this.name = 'AiRateLimitedError';
  }
}
